/**
 * Pure helpers for the Sign page save flow.
 *
 * `overlaysToEdits` converts the Sign-page overlay shape (normalized 0-1
 * coords, 0-based pageIndex) into the Scrivar "edits" shape the save pipeline
 * expects (absolute PDF points, 1-based pageNum) — the same shape the Viewer
 * uses.
 *
 * `signSaveOptions` chooses the save options for the two commit paths:
 *   - Sign & Save (flatten:true) → embed the visual signature in page content
 *     and strip the re-editable sidecar. This is not a digital certificate or
 *     tamper protection: the PDF can still be edited after saving.
 *   - Keep editable (flatten:false) → leave the signature as an editable overlay.
 */

export function overlaysToEdits(overlays, pageSizes) {
  return overlays.flatMap((o, i) => {
    const size = pageSizes[o.pageIndex];
    if (!size) return [];
    const pw = size.w;
    const ph = size.h;
    if (o.type === 'signature') {
      return [{
        id: o.id || `sign-overlay-${i}`,
        type: 'signature',
        pageNum: o.pageIndex + 1,
        x: o.x * pw,
        y: o.y * ph,
        width: o.w * pw,
        height: o.h * ph,
        content: o.dataUrl,
        styles: {},
      }];
    }
    // date or text — both render as plain text.
    const fontSize = (o.fontSize || 0.018) * ph;
    return [{
      id: o.id || `sign-overlay-${i}`,
      type: 'text',
      pageNum: o.pageIndex + 1,
      x: o.x * pw,
      y: o.y * ph,
      width: o.w * pw,
      height: fontSize * 1.4,
      content: o.text || '',
      styles: { fontSize, color: '#000000' },
    }];
  });
}

export function signSaveOptions({ flatten }) {
  return flatten
    ? { flatten: true, preserveOverlays: false }
    : { preserveOverlays: true };
}
